import {Collection} from 'vue-mc'
import CollectionFilter from '@/collections/CollectionFilter';
import _ from "lodash";

/**
 * base collection class
 */
export default class BaseCollection extends Collection {

  constructor() {

    // call parent
    super();

    // init query filter with empty filter
    this.resetFilter();
  }

  /**
   *
   * @returns {{count: number}}
   */
  defaults() {
    return {
      count: 0
    }
  }

  // Route configuration
  routes() {
    return _.merge(this.privateRoutes(), this.publicRoutes());
  }

  publicRoutes() {
    return {};
  }

  privateRoutes() {
    return {};
  }

  /**
   * resets the collection filter in the object
   * @returns {BaseCollection}
   */
  resetFilter() {
    this.Filter = new CollectionFilter();
    this.prepareFilter(this.Filter);
    return this;
  }

  /**
   *
   * @param CollectionFilter
   */
  prepareFilter(CollectionFilter) {
  }

  /**
   * Gets the collection filter held in the object
   * @returns {CollectionFilter}
   */
  getFilter() {
    return this.Filter;
  }

  /**
   * resets the collection filter in the object
   * @returns {BaseCollection}
   */
  setFilter(Filter) {

    if (typeof Filter === 'object') {
      this.Filter = Filter;
    }

    return this;
  }

  /**
   *
   * @param response
   * @returns {Array}
   */
  getModelsFromResponse(response) {
    let models = [];
    let data = response.getData();
    if (data.data) {
      data.data.forEach((insert) => {
        let temp = (new (this.model())(insert));
        models.push(temp);
      });
    }
    if (data.total) {
      this.set('count', data.total);
    }
    return models;
  }

  /**
   *
   * @param config
   * @returns {BaseCollection.createRequest|WebServiceModel.createRequest|BaseModel.createRequest|WebServiceCollection.createRequest}
   */
  createRequest(config) {
    //let token = window.$cookies.get('auth__access_token');
    let token = localStorage['auth__access_token'];
    config.headers = config.headers || {};
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }

    // get filter query
    let filter_query = this.getFilter().getQuery();

    // add filter query components
    if (filter_query.length) {
      config.url += '?' + filter_query;
    }

    // run request
    return new super.createRequest(config);
  }

  handleCustomFetchSuccess(response) {
    this.onFetchSuccess(response);
    return response;
  }

  handleCustomFetchFailure(response) {
    this.onFetchFailure(response);
    return response;
  }

}
